exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.tag-button_tag-button_3MxU5 {\n    padding: .625rem 1rem;\n    background: var(--looks-secondary);\n    border-radius: 1.375rem;\n    color: white;\n    height: 2.5rem;\n}\n\n.tag-button_tag-button-icon_3VB4Q {\n    max-width: 1rem;\n    max-height: 1rem;\n}\n\n.tag-button_active_1IIH9 {\n    background: var(--data-primary);\n}\n\n.tag-button_hidden_Mmf6D {\n    display: none;\n}\n\n", ""]);

// exports
exports.locals = {
	"tag-button": "tag-button_tag-button_3MxU5",
	"tagButton": "tag-button_tag-button_3MxU5",
	"tag-button-icon": "tag-button_tag-button-icon_3VB4Q",
	"tagButtonIcon": "tag-button_tag-button-icon_3VB4Q",
	"active": "tag-button_active_1IIH9",
	"hidden": "tag-button_hidden_Mmf6D"
};